/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementSearchResultsIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementSearchResultsIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 4C5.65685 4 7 5.34315 7 7C7 7.64777 6.79245 8.24598 6.44336 8.73633L8.85352 11.1465L8.14648 11.8535L5.73633 9.44336C5.24598 9.79245 4.64777 10 4 10C2.34315 10 1 8.65685 1 7C1 5.34315 2.34315 4 4 4ZM4 5C2.89543 5 2 5.89543 2 7C2 8.10457 2.89543 9 4 9C5.10457 9 6 8.10457 6 7C6 5.89543 5.10457 5 4 5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementSearchResultsIcon.tags = [
  'search',
  'results',
  'search results',
  'magnify',
  'find',
  'magnifying glass',
  'loupe',
  'zoom',
];

ElementSearchResultsIcon.category = 'Navigator';

ElementSearchResultsIcon.iconSize = 16;
